export enum BusinessNotiType {
  System = "system",
  JobApply = "job_apply",
}

export enum BusinessNotiSubjectType {
  Candidate = "candidate",
  Job = "job",
  Business = "business",
}

export interface NotificationMessageDto {
  id: string;
  businessId?: number;
  employeeId?: number;
  type?: BusinessNotiType;
  title?: string;
  content?: string;
  image?: string;
  actionUrl?: string;
  subject?: NotificationObject[];
  subjectCount?: number;
  diObject?: NotificationObject;
  inObject?: NotificationObject;
  prObject?: NotificationObject;
  isSeen?: boolean;
  isRead?: boolean;
}

export interface NotificationObject {
  id?: number;
  name?: string;
  type?: BusinessNotiSubjectType;
  uid?: string;
  image?: string;
  metadata?: Record<string, any>;
}

export function isNotificationMessageDto(data: any): boolean {
  return (
    data &&
    typeof data === "object" &&
    ("actionUrl" in data || "action_url" in data) &&
    "subject" in data
  );
}
